import { defineComponent as _defineComponent } from 'vue';
import { Slot } from "reka-ui";
import { useFormField } from "./useFormField";
export default /*@__PURE__*/ _defineComponent({
    __name: 'FormControl',
    setup(__props, { expose: __expose }) {
        __expose();
        const { error, formItemId, formDescriptionId, formMessageId } = useFormField();
        const __returned__ = { error, formItemId, formDescriptionId, formMessageId, get Slot() { return Slot; } };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
